
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/office",
      function () {
        return require("private-next-pages/[lang]/office/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/office"])
      });
    }
  